import { render, staticRenderFns } from "./EdenAttachments.vue?vue&type=template&id=2cfa4a8c&scoped=true"
import script from "./EdenAttachments.vue?vue&type=script&lang=js"
export * from "./EdenAttachments.vue?vue&type=script&lang=js"
import style0 from "./EdenAttachments.vue?vue&type=style&index=0&id=2cfa4a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa4a8c",
  null
  
)

export default component.exports